import CbuAccountType from './CbuAccountType'

export default CbuAccountType
